import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppConsts } from 'app/shared/services/app-const';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  public readonly materialTheme$: Observable<boolean>;
  public goBackText: string;
  public userPictureOnly: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  userMenu = [];

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.materialTheme$ = this.themeService.onThemeChange().pipe(
      map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }),
    );
  }

  ngOnInit() {
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl));

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.rippleService.toggle(themeName?.startsWith('material'));
      });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((route: ActivatedRoute) => {
      if (this.route.snapshot.firstChild.data) {
        this.goBackText = this.route.snapshot.firstChild.data.goBackText;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  public get userFullName(): string {
    return `${AppConsts?.loggedInUser?.fullName}`;
  }

  public navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  public goBack(): void {
    this.router.navigate(['../'], { relativeTo: this.route });
  }
}
